type NumberInputEvent =
  | React.KeyboardEvent<HTMLInputElement>
  | React.ClipboardEvent<HTMLInputElement>;

function isKeyDownEvent(
  event: NumberInputEvent,
): event is React.KeyboardEvent<HTMLInputElement> {
  return event.type === 'keydown';
}

const allowedKeys = [
  'Tab',
  'Backspace',
  'Delete',
  'Space',
  'ArrowUp',
  'ArrowDown',
  'Minus',
];

export const validateNumberInputEvent = (evt: NumberInputEvent) => {
  const theEvent = evt || window.event;

  let key = '';
  // Handle paste
  if (theEvent instanceof ClipboardEvent) {
    key = theEvent.clipboardData
      ? theEvent.clipboardData.getData('text/plain')
      : '';
  } else if (isKeyDownEvent(theEvent)) {
    // Handle key press
    key = theEvent.code;
  }
  if (allowedKeys.includes(key)) {
    return;
  }
  const regex = /[0-9]|\./;
  if (!regex.test(key)) {
    if (theEvent.preventDefault) theEvent.preventDefault();
  }
};
